import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Field, useFetch } from '@cordata/buffet';

import { authorizedPyInstance as Py } from '~/utils';
import { deburrObject } from '~/utils/api/normalizers';
import { camelCase, kebabCase } from 'lodash';

const ReferenceDataField = ({
  name,
  tableName,
  params,
  ...p
}) => {
  const [status, data] = useFetch(`data/reference/reference-${tableName || name}`, { instance: 'p', params: { ...params, sort: `default-sort-order,sort-order,${kebabCase(tableName || name)}-label` } });
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (typeof values[name] === 'string' && values[name] !== '') {
      Py.get(`api/data/reference/reference-${tableName || name}/${values[name]}`)
        .then(r => deburrObject(r.data.data))
        .then(r => setFieldValue(name, r));
    }
  }, []);

  return (
    <Field
      {...p}
      name={name}
      type="select"
      loading={status === 'loading'}
      options={(data || []).map(deburrObject)}
      getOptionValue={o => o.id}
      getOptionLabel={o => o[`${camelCase(tableName || name)}Label`] || o.attributes[`${camelCase(tableName || name)}Label`]}

    />
  );
};

ReferenceDataField.propTypes = {
  name: PropTypes.string.isRequired,
  tableName: PropTypes.string,
  params: PropTypes.shape(),
};

ReferenceDataField.defaultProps = {
  tableName: undefined,
  params: {},
};

export default ReferenceDataField;
